export default {
  title: 'Loyalty Tablet',
  headers: {
    customer_frequency: 'Customer frequency',
  },
};
